import React, { useState, useEffect, useRef } from "react";
import Topbar from "../Topbar/Topbar";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IoCloseOutline } from "react-icons/io5";
import "react-calendar/dist/Calendar.css";
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css
import "react-date-range/dist/theme/default.css"; // theme css
import { useSearchParams } from "react-router-dom";
import "./Stock.css";
import axios from "axios";
import Swal from "sweetalert2";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useSelector } from "react-redux";

const Stock = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const permission = useSelector((state) => state.permissions);
  const designation = useSelector((state) => state.designation);

  const [stockMaterials, setStockMaterials] = useState([]);
    const [namesList, setNamesList] = useState([]);
  const cardColors = [
    "yellow-card",
    "purple-card",
    "orange-card",
    "blue-card",
    "pink-card",
    "green-card",
    "red-card",
    "skyblue-card",
    "brown-card",
  ];


  //table stock data
  const [stocksDatas, setStocksData] = useState([]);

  const [searchTerm, setSearchTerm] = useState({
    date: "",
    category: "",
    name: "",
    updatedBy: "",
  });

  const [selectedRange, setSelectedRange] = useState("");
  const [stockSettingPopup, setStockSettingPopup] = useState(false);
  const [viewStockCount, setStockViewCount] = useState([]);
  const [checkboxState, setCheckboxState] = useState({
    date: true,
    category: true,
    updatedPerson: true,
    vendorCustomerName: true,
    fiberCable: true,
    router: true,
    splitter: true,
    closureBox: true,
    patchChord: true,
    cat6Cable: true,
  });


  const navigate = useNavigate();
  //setting popup
  // Helper function to check if all are selected
  const areAllSelected = () =>
    Object.keys(checkboxState)
      .filter((key) => key !== "selectAll" && key !== "unselectAll")
      .every((key) => checkboxState[key]);

  // Helper function to check if all are unselected
  const areAllUnselected = () =>
    Object.keys(checkboxState)
      .filter((key) => key !== "unselectAll" && key !== "selectAll")
      .every((key) => !checkboxState[key]);

  // Handle individual checkbox change
  const handleCheckboxChange = (key) => {
    setCheckboxState((prevState) => {
      const updatedState = { ...prevState, [key]: !prevState[key] };

      // Dynamically update Select All/Unselect All
      updatedState.selectAll = areAllSelected();
      updatedState.unselectAll = areAllUnselected();

      return updatedState;
    });
  };
  const gotoaddStock = (e) => {
    e.preventDefault();
    navigate("/addstock");
  };

 const handleOpenDatePopup = () => {
  setDatePopup(true);
  setShowCustom(true); // Directly open Custom Range
};
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const [dateFilter, setDateFilter] = useState({ start: null, end: null });
//funtionality for this option 


// const setPredefinedRange = (days) => {
//   const end = new Date();
//   const start = new Date();
//   start.setDate(start.getDate() - days);
//   setRange([{ startDate: start, endDate: end, key: "selection" }]);
//   setShowCustom(false); // Close calendar, show filtered results if needed
//   handleApply(); // Directly apply
// };
const today = new Date();
today.setHours(0, 0, 0, 0); // Midnight start

const setPredefinedRange = (type) => {
  let start = new Date();
  let end = new Date();

  switch (type) {
    case "today":
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      break;

    case "yesterday":
      start.setDate(start.getDate() - 1);
      start.setHours(0, 0, 0, 0);
      end = new Date(start);
      end.setHours(23, 59, 59, 999);
      break;

    case "last7":
      end.setHours(23, 59, 59, 999);
      start.setDate(start.getDate() - 6); // includes today + previous 6 days
      start.setHours(0, 0, 0, 0);
      break;

    case "last30":
      end.setHours(23, 59, 59, 999);
      start.setDate(start.getDate() - 29); // includes today + previous 29 days
      start.setHours(0, 0, 0, 0);
      break;

    case "thisMonth":
      start = new Date(end.getFullYear(), end.getMonth(), 1);
      start.setHours(0, 0, 0, 0);
      end.setHours(23, 59, 59, 999);
      break;

    default:
      return;
  }

  setRange([{ startDate: start, endDate: end, key: "selection" }]);
  setDateFilter({ start, end });
  setSelectedRange(`${start.toLocaleDateString()} - ${end.toLocaleDateString()}`);
  setDatePopup(false);
  setShowCustom(false);
};




//handle open calendar
  const handleSettingOpen = () => {
    setStockSettingPopup(true);
  };
//handle close calendar
  const handleSettingClose = () => {
    setStockSettingPopup(false);
  };
  
  // Handle search input change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setSearchTerm((prevFilters) => ({
      ...prevFilters,
      [name]: value.toLowerCase(), // Normalize input for case-insensitive search
    }));
  };
  // Filter the stocksData based on the search term
const filteredData = stocksDatas.filter((item) => {
  // Date filtering
  if (dateFilter.start && dateFilter.end) {
    const itemDate = new Date(item.date);
    if (itemDate < dateFilter.start || itemDate > dateFilter.end) {
      return false;
    }
  }

  // Other search filters
  return Object.keys(searchTerm).every((key) => {
    if (!searchTerm[key]) return true;
    return String(item[key]).toLowerCase().includes(searchTerm[key]);
  });
});

  const materialStructure = {};
  filteredData.forEach((entry) => {
    entry.materials.forEach((mat) => {
      if (!materialStructure[mat.material]) {
        materialStructure[mat.material] = new Set();
      }
      materialStructure[mat.material].add(mat.materialType);
    });
  });

  // Convert Sets to arrays
  Object.keys(materialStructure).forEach((key) => {
    materialStructure[key] = Array.from(materialStructure[key]);
  });
  const camelCase = (str) =>
    str
      .replace(/\s(.)/g, (match, group1) => group1.toUpperCase())
      .replace(/^./, (s) => s.toLowerCase());

  const [shouldExport, setShouldExport] = useState(false);
  //Export PopUp
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Stock_data",
    sheet: "Stock",
  });
  //popup confirmation for export
  const handleExportConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to export the Stock details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, export it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
        setShouldExport(true); // Allow the export to proceed
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The export operation was cancelled.", "error");
        setShouldExport(false);
      }
    });
  };
  function formatUnit(unit, category) {
    if (!unit) return ""; // Return empty if no material found.

    // Negate the unit for specific categories
    if (
      ["damage", "installation", "complaint"].includes(category.toLowerCase())
    ) {
      return unit > 0 ? `-${unit}` : unit;
    }

    // Return the unit in its original state otherwise
    return unit;
  }




  const [datePopup, setDatePopup] = useState(false);
const [showCustom, setShowCustom] = useState(true);
const [range, setRange] = useState([
  {
    startDate: new Date(),
    endDate: new Date(),
    key: "selection"
  }
]);

const handleClosePopUp = () => {
  setDatePopup(false);
  setShowCustom(false);
};

const handleCancel = () => {
  setShowCustom(false);
};

const handleApply = () => {
  const selectedStart = range[0].startDate;
  const selectedEnd = range[0].endDate;

  setSelectedRange(
    `${selectedStart.toLocaleDateString()} - ${selectedEnd.toLocaleDateString()}`
  );

  // Store in filter state
  setDateFilter({ start: selectedStart, end: selectedEnd });

  setDatePopup(false);
  setShowCustom(false);
};



  //fetch count
  useEffect(() => {
    axios
      .get(apiUrl + "stock/summary", {})
      .then((res) => {
        setStockViewCount(res.data);
        console.log(res.data);
      })
      .catch((error) => {
        console.error("Error fetching", error);
      });
  }, [apiUrl, setStockViewCount]);

  // Fetch stock materials on component load
  useEffect(() => {
    const fetchStockMaterials = async () => {
      try {
        const response = await axios.get(`${apiUrl}manage-stock/get-all`);
        setStockMaterials(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        if (error.response.data.message === "No materials found") {
          Swal.fire(
            "Add Material",
            "Oops! It looks like there are no materials. Add one to proceed",
            "info"
          );
        } else {
          Swal.fire("Error!", "Failed to fetch stock materials", "error");
        }
      }
    };

    fetchStockMaterials();
  }, [apiUrl]);
  useEffect(() => {
  const fetchData = async () => {
    try {
      const materialsRes = await axios.get(`${apiUrl}manage-stock/get-all`);
      const summaryRes = await axios.get(`${apiUrl}stock/summary`);

      setStockMaterials(Array.isArray(materialsRes.data) ? materialsRes.data : []);
       setStockViewCount(Array.isArray(summaryRes.data) ? summaryRes.data : []);
    } catch (error) {
      console.error("Error fetching stock data", error);
    }
  };

  fetchData();
}, [apiUrl]);

  useEffect(() => {
    axios
      .get(apiUrl + "/stock/entries")
      .then((res) => {
        setStocksData(res.data); // keep your original state update

        // Extract unique names from response
        const uniqueNames = [
          ...new Set(res.data.map((item) => item.updatedBy).filter(Boolean)),
        ];
        setNamesList(uniqueNames);
      })
      .catch((error) => {
        console.error("Error fetching", error);
      });
  }, [apiUrl, setStocksData]);
  // Fetch stock materials and update checkbox state dynamically
useEffect(() => {
  const fetchData = async () => {
    try {
      const materialRes = await axios.get(`${apiUrl}manage-stock/get-all`);
      setStockMaterials(materialRes.data || []);

      const dynamicCheckboxes = {};
      (materialRes.data || []).forEach((item) => {
        const key = item.material; // Group by material for the main column toggle
        if (key) {
          dynamicCheckboxes[camelCase(key)] = true;
        }
      });

      setCheckboxState((prevState) => ({
        ...prevState,
        ...dynamicCheckboxes,
      }));
    } catch (error) {
      console.error("Error loading stock data", error);
    }
  };

  fetchData();
}, []);

  return (
    <div>
      <Topbar />
      <Container fluid>
        <h3 className=" px-2  ">Stock</h3>
        {permission?.Stock?.["Stock Statistics"]?.Read && (
          <Row className="">
            {/* {defaultCards.map((card, index) => {
              // Match the backend data to this card by title (case-insensitive)
              const match = viewStockCount.find(
                (item) =>
                  item.materialType?.toLowerCase() ===
                    card.title.toLowerCase() ||
                  item.material?.toLowerCase() === card.title.toLowerCase()
              );

              const count = match ? match.totalStock : 0;

              return (
                <Col key={index} className="dashborder mt-4 mb-5 mx-2">
                  <Row className={card.class}>
                    <p className="text-center box-txt">{card.title}</p>
                  </Row>
                  <Row className="number">
                    <h5 className="text-center pt-2">{count}</h5>
                  </Row>
                </Col>
              );
            })} */}

<div className="scroll-wrapper">
  <Row className="flex-nowrap">
  {stockMaterials.map((material, index) => {
  const title = material.materialType || material.material;
  const match = viewStockCount.find(
    (item) =>
      item.materialType?.toLowerCase() === material.materialType?.toLowerCase()
  );
  const count = match ? match.totalStock : 0;

  const colorClass = cardColors[(index + 1) % cardColors.length]; // ✅ fixed here

  return (
    <Col key={index} className="dashborder_stock stock-card">
      <Row className={colorClass}>
        <p className="text-center box-txt">{title}</p>
      </Row>
      <Row className="number">
        <h5 className="text-center pt-2">{count}</h5>
      </Row>
    </Col>
  );
})}

  </Row>
</div>
          </Row>
        )}

        <Row className="" xs={1} sm={2}>
          <Col className="mt-2 mb-2">
            {permission?.Stock?.["Add Stock"]?.Write && (
              <button onClick={gotoaddStock} className="black-btn">
                Add
              </button>
            )}
            &emsp;&emsp;
            <button
              onClick={() => window.location.reload()}
              className="black-btn "
            >
              Refresh
            </button>
          </Col>

          <Col className="mt-2 text-end">
            {/* <button
              className="black-btn black-btn1 btnadd"
              onClick={
                designation === "Super Admin" && filteredData.length > 0
                  ? handleExportConfirmation
                  : undefined
              }
              disabled={
                designation !== "Super Admin" || filteredData.length === 0
              }
              style={{
                opacity:
                  designation === "Super Admin" && filteredData.length > 0,
                cursor:
                  designation === "Super Admin" && filteredData.length > 0
                    ? "pointer"
                    : "not-allowed",
              }}
              title={
                designation !== "Super Admin"
                  ? "Only Super Admin can export"
                  : filteredData.length === 0
                  ? "No data to export"
                  : "Export"
              }
            >
              Export
            </button> */}
            &emsp;&emsp;
            {permission?.Stock?.["Stock Module"]?.Read && (
              <button className="black-btn" onClick={handleSettingOpen}>
                Settings
              </button>
            )}
          </Col>
        </Row>
        <br />
        <div className="table-scroll">
          {permission?.Stock?.["Stock Module"]?.Read && (
            <table className="table table-bordered stock-table" ref={tableRef}>
              <thead className="table-th text-center table-th-re">
                <tr>
                  {checkboxState.date && <td rowSpan={2}>Date</td>}
                  {checkboxState.category && <td rowSpan={2}>Category</td>}
                  {checkboxState.vendorCustomerName && (
                    <td rowSpan={2}>Vendor And Customer Name</td>
                  )}
                  {checkboxState.updatedPerson && (
                    <td rowSpan={2}>Updated By</td>
                  )}

                  {Object.entries(materialStructure).map(([material, types]) =>
                    checkboxState[camelCase(material)] ? (
                      <td
                        colSpan={types.length}
                        className="wrap"
                        key={material}
                      >
                        {material}
                      </td>
                    ) : null
                  )}
                </tr>
                <tr>
                  {Object.entries(materialStructure).map(
                    ([material, types]) =>
                      checkboxState[camelCase(material)] &&
                      types.map((type) => (
                        <td
                          key={`${material}-${type}`}
                          className="wrap sub-bg-color"
                        >
                          {type}
                        </td>
                      ))
                  )}
                </tr>
              </thead>

              <tbody>
                <tr>
                  {checkboxState.date && (
                    <td>
                      <input
                        placeholder="Select date"
                        className="filter-input bg-white table-search stock-search-wrap"
                        name="date"
                        onClick={handleOpenDatePopup}
                        onFocus={handleOpenDatePopup}
                        readOnly
                        value={selectedRange}
                      />
                    </td>
                  )}
                  {checkboxState.category && (
                    <td>
                      <select
                        class="filter-select bg-white table-search"
                        name="category"
                        onChange={handleFilterChange}
                      >
                        <option value="">Select</option>
                        <option value="Purchase">Purchase</option>
                        <option value="Recovery">Recovery</option>
                        <option value="Damage">Damage</option>
                        <option value="Instalation">Instalation</option>
                        <option value="Complaint">Complaint</option>
                      </select>
                    </td>
                  )}
                  {checkboxState.vendorCustomerName && (
                    <td>
                      <input
                        type="text"
                        class="filter-input bg-white table-search "
                        placeholder="Search"
                        name="name"
                        autoComplete="off"
                        style={{ width: "100%" }}
                        onChange={handleFilterChange}
                      />
                    </td>
                  )}
                  {checkboxState.updatedPerson && (
                  <td>
      <select
        className="filter-select bg-white table-search"
        name="updatedBy"
        autoComplete="off"
        onChange={handleFilterChange}
      >
        <option value="">Select</option>
        {namesList.map((name, index) => (
          <option key={index} value={name}>
            {name}
          </option>
        ))}
      </select>
    </td>
                  )}
                </tr>

                {filteredData.map((entry, index) => (
                  <tr key={index}>
                    {/* Static Columns */}
                    {checkboxState.date && (
                      // <td>
                        
                      //   {new Date(entry.date).toISOString().split("T")[0]}
                      // </td>
                      
                     <td>{formatDate(entry.date)}</td>
                    )}
                    {checkboxState.category && <td>{entry.category}</td>}
                    {checkboxState.vendorCustomerName && <td>{entry.name}</td>}
                    {checkboxState.updatedPerson && <td>{entry.updatedBy}</td>}

                    {/* Dynamic Material Data */}
                    {Object.entries(materialStructure).map(
                      ([material, types]) =>
                        checkboxState[camelCase(material)] &&
                        types.map((type) => {
                          // Find if the entry has this material + materialType
                          const found = entry.materials.find(
                            (m) =>
                              m.material === material && m.materialType === type
                          );

                          return (
                            <td
                              key={`${material}-${type}`}
                              className="text-center"
                            >
                              {formatUnit(found?.unit, entry.category)}{" "}
                              {/* Display unit if exists */}
                            </td>
                          );
                        })
                    )}
                  </tr>
                ))}
              </tbody>
              {datePopup && (
                <div className="popup-overlay" onClick={handleClosePopUp}>
                  <div
                    className="date-picker-wrapper"
                    onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                  >
                    {/* Sidebar */}
                    <div className="date-sidebar">
                   <ul>
  <IoCloseOutline className="stock-cross" onClick={handleClosePopUp} />
 <li onClick={() => setPredefinedRange("today")}>Today</li>
<li onClick={() => setPredefinedRange("yesterday")}>Yesterday</li>
<li onClick={() => setPredefinedRange("last7")}>Last 7 Days</li>
<li onClick={() => setPredefinedRange("last30")}>Last 30 Days</li>
<li onClick={() => setPredefinedRange("thisMonth")}>This Month</li>
<li onClick={() => setShowCustom(true)}>Custom Range</li>
</ul>
                    </div>

                    {/* Calendar Panel */}
                    {showCustom && (
                      <div className="calendar-panel">
                        <DateRange
                          editableDateInputs={true}
                          onChange={(item) => setRange([item.selection])}
                          moveRangeOnFirstSelection={false}
                          ranges={range}
                          months={2}
                          direction="horizontal"
                          showDateDisplay={false}
                        />
                        <div className="calendar-footer">
                          <input
                            type="text"
                            value={range[0].startDate.toLocaleDateString()}
                            readOnly
                          />
                          <input
                            type="text"
                            value={range[0].endDate.toLocaleDateString()}
                            readOnly
                          />
                          <button onClick={handleCancel}>Cancel</button>
                          <button onClick={handleApply}>Apply</button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </table>
          )}
          {stockSettingPopup && (
            <div className="stock-popup-overlay">
              <div className="stock-popup-container">
                <IoCloseOutline
                  className="stock-popup-close-icon"
                  onClick={handleSettingClose}
                />
                <form>
                  <label>
                    <input
                      className="checkbox-customer"
                      type="checkbox"
                      checked={Object.values(checkboxState).every((v) => v)}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setCheckboxState(
                          Object.keys(checkboxState).reduce((acc, key) => {
                            acc[key] = isChecked;
                            return acc;
                          }, {})
                        );
                      }}
                    />
                    <span
                      className="checkbox-down ms-1"
                      style={{ fontSize: "17px" }}
                    >
                      {Object.values(checkboxState).every((v) => v)
                        ? "Unselect All"
                        : "Select All"}
                    </span>
                  </label>

                  <div className="staff-popup-grid">
                    {Object.keys(checkboxState)
                      .filter(
                        (key) => key !== "selectAll" && key !== "unselectAll"
                      )
                      .map((key) => (
                        <label className="checkbox-label" key={key}>
                          <input
                            type="checkbox"
                            className="setting-label"
                            checked={checkboxState[key]}
                            onChange={() => handleCheckboxChange(key)}
                          />
                          {/* Convert camelCase back to readable text for labels */}
                          {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                        </label>
                      ))}
                  </div>

                  <div className="stocksetting-popup-footer">
                    <button
                      type="submit"
                      className="submit-btn"
                      onClick={handleSettingClose}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </Container>
      
    </div>
  );
};
export default Stock;
